import React from 'react';
import { Button } from 'semantic-ui-react';
import $ from "jquery";

import Title from '../../title';
import GetDate from '../../../functions/date';
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import MakeDecimalPoints from '../../makedecimalpoints';
import View from './view';

class Payment extends React.Component {

    state = {
        fromDate: GetDate(new Date(), 'fromDate'), //Set From Date
        toDate: GetDate(new Date(), 'toDate'), //Set To Date
        data: [], menuPermission: []
    }

    componentDidMount() {
        this.menuControl();
    }

    menuControl() {
        let menuPermission = Permission('machine-customer-statement', this.props.menus);
        if (menuPermission.view) {
            this.getCustomerData();
        }
        this.setState({ menuPermission })
    }

    getCustomerData() {
        let context = this;
        let { fromDate, toDate } = this.state;
        $.ajax({
            type: 'POST', data: { fromDate, toDate },
            url: Server()+'machine/statement/get.php',
            success: function(data) {
                console.log(data);
                console.log('datatatat');
                try {
                    data = JSON.parse(data);
                    
                    context.setState({ data, load: false })
                } catch (error) {
                    alert('Try Agian!!!');
                    context.setState({ load: false })
                }
            },
            error: function(e) {
                alert('Try again!!')
            }
        });
    }

    convertIntoNumber(value) {
        try {
            value = Number(value);
        } catch (error) {
            value = 0 ;
        }
        return value;
    }

    render() {
        let sino = 1;
        return (
            <div>
                <Title title='Machine Customer Statment' openDrawer={this.props.openDrawer}/>
                { this.state.menuPermission.view ?
                    (
                        <div>
                            <div style={{margin: '5px'}}>
                                <div style={{display: 'flex', margin: '5px'}}>
                                    <div>
                                        <b>From Date</b><br/>
                                        <input type="date" value={this.state.fromDate} style={{width: '100%', height: 35 }}
                                            onChange={ (event) => { this.setState({ fromDate: event.target.value }) }} />
                                    </div>
                                    <div style={{marginLeft: '2px'}}>
                                        <b>To Date</b><br/>
                                        <input type="date" value={this.state.toDate} style={{width: '100%', height: 35 }}
                                            onChange={ (event) => { this.setState({ toDate: event.target.value }) }} />
                                    </div>
                                    <div style={{marginLeft: '2px'}}>
                                        <br/>
                                        <Button onClick={this.getCustomerData.bind(this)}>Submit</Button>
                                    </div>
                                </div>
                            </div>
                            <div style={{margin: '5px'}}>
                                <table id="table" width="100%">
                                    <tr id="th">
                                        <th>Sino</th>
                                        <th>Name</th>
                                        <th>Mobile</th>
                                        <th>Taluk</th>
                                        <th>State</th>
                                        <th>Opening Balance</th>
                                        <th>Closing Balance</th>
                                        <th>View</th>
                                    </tr>
                                    {
                                        this.state.data.map((c) => {
                                            let openingBalance = this.convertIntoNumber(c.opening_balance);
                                            let closingBalance = this.convertIntoNumber(c.closing_balance);
                                            return (
                                                <tr>
                                                    <td>{sino++}</td>
                                                    <td>{c.name}</td>
                                                    <td>{c.mobile}</td>
                                                    <td>{c.taluk}</td>
                                                    <td>{c.state}</td>
                                                    <td><div style={{textAlign: 'right', fontWeight: 'bold'}}>{'Rs. '+MakeDecimalPoints(openingBalance)}</div></td>
                                                    <td><div style={{textAlign: 'right', fontWeight: 'bold'}}>{'Rs. '+MakeDecimalPoints(closingBalance)}</div></td>
                                                    <td><center><View name={c.name} id={c.cid} fromDate={this.state.fromDate} toDate={this.state.toDate} openingBalance={openingBalance} closingBalance={closingBalance}  /></center></td>
                                                </tr>
                                            )
                                        })
                                    }
                                </table>
                            </div>
                        </div>
                    ):
                    (
                        <center>You ARe Not Allow To Access This Menu</center>
                    )
                }
                
            </div>
        );
    }
}

export default Payment;
